// --
import PropTypes from 'prop-types';

import React from 'react';
import {Form} from 'react-bootstrap';
import {Spinner} from '@fluentui/react-components';
import {AbstractReactComponent, Icon} from 'components/shared';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { messageFor } from 'components/shared/lang/dynamicMessage';

// Id jsou převzatá z legacy katalogu beze změny.
const messages = defineMessages({
    deleteNode: { id: 'arr.fund.nodes.deleteNode', defaultMessage: 'Opravdu chcete smazat tuto položku?' },
    selectNodes: { id: 'arr.fund.nodes.title.select', defaultMessage: 'Výběr jednotek popisu' },
    activePermission: { id: 'permission.activePermission.title', defaultMessage: 'Aktivní oprávnění' },
    source: { id: 'permission.source.title', defaultMessage: 'Zdroj' },
    explicit: { id: 'permission.explicit.title', defaultMessage: 'Explicitní' },
});
import getMapFromList from '../../shared/utils/getMapFromList';
import './PermissionCheckboxsForm.scss';
import TooltipTrigger from '../shared/tooltip/TooltipTrigger';
import {modalDialogShow} from '../../actions/global/modalDialog.jsx';
import FundNodesList from '../arr/FundNodesList';
import FundNodesSelectForm from '../arr/FundNodesSelectForm';
import {connect} from 'react-redux';
import {WebApi} from '../../actions';
import {FUND_ARR_NODE} from '../../actions/user/Permission';
import { showConfirmDialog } from 'components/shared/dialog';
import { fundPermissionMessages } from './permissionMessages';

/**
 * Panel spravující oprávnění typu checkbox.
 */
class PermissionCheckboxsForm extends AbstractReactComponent {
    static propTypes = {
        permCodes: PropTypes.array.isRequired, // seznam kódů oprávnění
        onChangePermission: PropTypes.func.isRequired, // callback při změně
        onAddNodePermission: PropTypes.func, // callback při přidání oprávnění na JP (povinné pokud je nastaveno fundId)
        onRemoveNodePermission: PropTypes.func, // callback při odebrání oprávnění na JP (povinné pokud je nastaveno fundId)
        permissionMessages: PropTypes.object.isRequired, // mapa deskriptorů popisků oprávnění
        permission: PropTypes.object.isRequired, // oprávnění, které se edituje
        permissionAll: PropTypes.object, // oprávnění pro all položky, pokud exisutje (a needituje se právě ono, tedy je naplněno pouze pokud permission !== permissionAll a vůbec permissionAll může existovat)
        permissionAllMessage: PropTypes.object, // deskriptor popisku zdroje "všechna oprávnění"
        groups: PropTypes.array, // seznam přiřazených skupin
        fundId: PropTypes.number,
        disabled: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            nodes: [],
            pendingPermCodes: new Set(),
        };
    }

    componentDidMount() {
        this.fetch(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.fundId !== this.props.fundId || nextProps.permission !== this.props.permission) {
            if (
                nextProps.fundId == null
                    || nextProps.permission?.id == null
                    || nextProps.permission.id.toString() !== nextProps.fundId.toString()
            ){
                this.setState({nodes: []});
                return;
            }
            this.fetch(nextProps);
        }
    }

    fetch = props => {
        if (props.fundId) {
            let nodes = [];
            const fundArrData = props.permission[FUND_ARR_NODE];

            if (fundArrData && fundArrData.ids) {
                nodes = fundArrData.ids;
            } else if (fundArrData && fundArrData.groupIds) {
                nodes = fundArrData.groupIds[props.groupId] ? fundArrData.groupIds[props.groupId][props.fundId] : [];
            }

            if (nodes && nodes.length > 0) {
                WebApi.findNodeByIds(props.fundId, nodes).then(nodes => {
                    this.setState({nodes});
                });
            } else {
                this.setState({nodes: []});
            }
        }
    };

    renderNodes = () => {
        return (
            <FundNodesList
                nodes={this.state.nodes}
                addInLabel
                addLabel={fundPermissionMessages['FUND_ARR_NODE.add']}
                onDeleteNode={this.handleRemoveNode}
                onAddNode={this.handleAddNodes}
                fundId={this.props.fundId}
            />
        );
    };

    handleRemoveNode = async (node) => {
        const {dispatch} = this.props;
        const response = await dispatch(showConfirmDialog(this.props.intl.formatMessage(messages.deleteNode)));
        if (response) {
            this.props.onRemoveNodePermission(this.props.fundId, node);
        }
    };

    handleAddNodes = () => {
        this.props.dispatch(
            modalDialogShow(
                this,
                this.props.intl.formatMessage(messages.selectNodes),
                <FundNodesSelectForm
                    fundId={this.props.fundId}
                    onSubmitForm={(ids, nodes) => {
                        this.props.onAddNodePermission(this.props.fundId, nodes);
                    }}
                />,
            ),
        );
    };

    handleChangePermission = (e, permCode) => {
        const {onChangePermission} = this.props;
        this.setState(({pendingPermCodes}) => ({
            pendingPermCodes: new Set([...pendingPermCodes, permCode]),
        }));
        const promise = onChangePermission(e, permCode);
        if (promise) {
            promise.finally(() => {
                this.setState(({pendingPermCodes}) => {
                    const next = new Set(pendingPermCodes);
                    next.delete(permCode);
                    return {pendingPermCodes: next};
                });
            });
        }
    };

    render() {
        const {permissionAllMessage, groups, permission, permissionMessages, permCodes, disabled} = this.props;
        const {pendingPermCodes} = this.state;
        const groupMap = groups ? getMapFromList(groups) : {};

        return (
            <div className="permission-checkbox-form">
                <div className="items-left">
                    {permCodes.map(permCode => {
                        const obj = permission[permCode] || {groupIds: {}};
                        let checked = false;
                        if (obj && obj.checked) {
                            checked = true;
                        }

                        // Odkomentovat jen pokud bychom chtěli zobrazovat "dědění" z položky "všechny ..."
                        // let allChecked = (permissionAll && permissionAll[permCode]) ? permissionAll[permCode].checked : false;
                        let allChecked = false;

                        let infoIcon;
                        let infoMessage;
                        if (pendingPermCodes.has(permCode)) {
                            infoIcon = <Spinner style={{marginRight: "10px"}} size="tiny" />;
                        } else if (Object.keys(obj.groupIds).length > 0 || checked || allChecked) {
                            const groupNames = Object.keys(obj.groupIds).map(id =>
                                groupMap[id] ? groupMap[id].name : '',
                            );
                            infoIcon = <Icon style={{color: 'green'}} glyph="fa-check" />;

                            infoMessage = (
                                <div className="permission-checkbox-form-tooltip">
                                    <div><FormattedMessage {...messages.activePermission} /></div>
                                    <br />
                                    <div><FormattedMessage {...messages.source} />:</div>
                                    <ul>
                                        {groupNames.map(x => (
                                            <li>{x}</li>
                                        ))}
                                        {allChecked && permissionAllMessage && <li><FormattedMessage {...permissionAllMessage} /></li>}
                                        {checked && <li><FormattedMessage {...messages.explicit} /></li>}
                                    </ul>
                                </div>
                            );
                        } else {
                            infoIcon = <Icon style={{visibility: 'hidden'}} glyph="fa-check" />;
                        }

                        if (infoMessage) {
                            infoIcon = (
                                <TooltipTrigger style={{width: "auto"}} key="info" content={infoMessage} placement="left" showDelay={1}>
                                    {infoIcon}
                                </TooltipTrigger>
                            );
                        }

                        return (
                            <div className="item-row" key={permCode}>
                                <div className="icon-wrapper">{infoIcon}</div>
                                <Form.Check
                                    type="checkbox"
                                    inline
                                    checked={checked}
                                    disabled={disabled || pendingPermCodes.size > 0}
                                    onChange={e => this.handleChangePermission(e, permCode)}
                                    label={<FormattedMessage {...messageFor(permissionMessages, permCode, messages.explicit)} />}
                                />
                            </div>
                        );
                    })}
                </div>
                {this.props.fundId && <div className="items-right">{this.renderNodes()}</div>}
            </div>
        );
    }
}

export default connect()(injectIntl(PermissionCheckboxsForm));
